import { render, staticRenderFns } from "./BPJSPatient.vue?vue&type=template&id=3b516b47&scoped=true"
import script from "./BPJSPatient.vue?vue&type=script&lang=js"
export * from "./BPJSPatient.vue?vue&type=script&lang=js"
import style0 from "./BPJSPatient.vue?vue&type=style&index=0&id=3b516b47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b516b47",
  null
  
)

export default component.exports